<template>
    <v-btn
        @click="emitClick"
        :style="buttonRoundnessStyle(settings.buttonRoundness)"
        :outlined="makeOutlined"
        :elevation="makeElevation"
        :class="makeClass"
        :color="makeColor"
        :dark="makeDark"
        :text="text"
        :left="left"
        :right="right"
        :disabled="disabled"
        :loading="loading"
        :tabindex="makeTabIndex"
    >
        <slot/>
    </v-btn>
</template>

<script>
import buttonStylesMixin from "@/components/mixins/buttonStylesMixin";
import colorMixin from "@/components/mixins/colorMixin";

export default {

    name: 'NinjaButton',

    mixins: [
        buttonStylesMixin,
        colorMixin,
    ],

    props: {
        settings: {
            type: Object,
            required: true,
        },
        text: {
            type: Boolean,
            required: false,
            default: false,
        },
        left: {
            type: Boolean,
            required: false,
            default: false,
        },
        right: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        color: {
            type: String,
            required: false,
            default: undefined,
        },
        background: {
            type: String,
            required: false,
            default: undefined,
        },
        tabIndex: {
            type: Number|null,
            required: false,
            default: null,
        },
    },

    computed: {
        makeClass() {
            const classes = [];

            if (this.text === false && (!this.settings.buttonOutlined || this.settings.buttonOutlined === false)) {
                classes.push(this.getFontClasses(this.settings.actionButtonColor));
            }

            if (this.text === true && this.background !== undefined) {
                classes.push(this.getFontClasses(this.background));
            }

            return classes.join(' ');
        },

        makeColor() {
            if (this.color !== undefined) {
                return this.color;
            }

            if (this.text) {
                if (this.background !== undefined) {
                    return this.getFontClasses(this.background);
                }

                if (this.isDarkColor(this.settings.foregroundColor)) {
                    return this.getFontClasses(this.settings.foregroundColor);
                }

                return 'grey darken-2';
            }

            return this.settings.actionButtonColor;
        },

        makeDark() {
            if (this.background !== undefined) {
                return this.isDarkColor(this.background);
            }

            return this.isDarkColor(this.settings.foregroundColor);
        },

        makeOutlined() {
            if (this.text) {
                return false;
            }

            return this.settings.buttonOutlined;
        },

        makeElevation() {
            if (this.text) {
                return 0;
            }

            return this.buttonShadowValue(this.settings.buttonShadow);
        },

        makeTabIndex() {

            // https://developer.mozilla.org/en-US/docs/web/html/global_attributes/tabindex
            if (this.tabIndex === -1 || this.tabIndex === 0) {
                return this.tabIndex;
            }

            return '';
        },
    },

    methods: {
        emitClick(e) {
            this.$emit('click', e);
        },
    },

}
</script>
